export const english = {
  home: {
    titolo: "The reporting form",
    introduzione1: "This form cannot be used to report general interest wrongdoings as a whistleblower. For such reports, please refer to the dedicated service at the following link: ",
    introduzione2: "The reporting module is a section of the Authority's portal that allows users to:",
    list_item1: "Identify the form to use based on the scope and nature of the reported issue.",
    list_item2: "Fill out the form online.",
    list_item3: "Submit the report online, and upon registration, receive an email indicating the practice number, date, and protocol number.",
    introduzione3: "After requesting the initial identifying data of the reporter, the form requires the identification of the area to which the report pertains, distinguishing between:",
    list_item4: {
      titolo: "Public Contracts: ",
      desc: "This area is responsible for receiving all reports related to violations of the discipline on the awarding and execution of public contracts for works, services, and supplies, whether they are contracts or concessions. This area also includes all reports related to: public-private partnerships; project finance; in-house contracts; procurement centers; conflicts of interest in the conduct of procurement procedures for contracts and concessions; secret contracts; assignments to general contractors."
    },
    list_item5: {
      titolo: "Anti-corruption: ",
      desc: "This area is responsible for receiving all reports aimed at activating the supervisory powers of the Authority concerning the verification of anti-corruption prevention measures, with particular reference to the adoption of the Triennial Plans for the Prevention of Corruption and Transparency (PTPCT) and the appointment of the Responsible for the Prevention of Corruption and Transparency (RPCT)."
    },
    list_item6: {
      titolo: "Assignment of duties and impartiality: ",
      desc: "This area is responsible for receiving all reports related to cases of ineligibility, incompatibility, failure to activate conflict of interest prevention measures within the organization, or related to the content of the codes of conduct, as described more comprehensively in the specific area."
    },
    list_item7: {
      titolo: "Transparency: ",
      desc: "This area is responsible for receiving all reports related to the failure to comply with the obligations of publication and transparency identified by Law 190/2012 and Legislative Decree 33/2013."
    }
  },
  buttons: {
    prosegui: "Continue",
    proseguiSPID: "Continue with SPID"
  },
  info: {
    alert1: "Warning: Some autocomplete services are not available. The unavailability of autocomplete services does not prevent the correct submission of the report.",
    alert2: "The application is currently unavailable. Please try again later.",
    alert3: "Retrieving data from the save of "
  },
  salvato_in_bozza: "Data saved as draft.",
  cf_non_trovato: "FISCAL CODE NOT FOUND",
  denominazione: "Registered Name:",
  cf: "Fiscal Code:",
  localizzazione: "Location:",
  natura_giuridica: "Legal Status:",
  stazione_appaltante: "Contracting Entity",
  oggetto_gara: "Object of the Tender:",
  importo_complessivo: "Total Amount",
  cig: "CIG",
  end: {
    info1: "The report has been successfully submitted.",
    info2: "Shortly, you will receive a PDF copy of the submission at the email address provided for contact.",
    info3: "Protocol:",
    downloadPDF: "Download PDF Document"
  },
  "complete": "Sottomissione completa",
  "cancel": "Cancella",
  "next": "Next",
  "previous": "Previous section",
  "submit": "Invia e completa la sottomissione",
  "Drop files to attach,": "Aggiungere i file spostandoli in quest'area,",
  "or": "oppure",
  "browse": "cliccare qui e cercare il file da allegare",
  "No choices to choose from": "nessuna selezione disponibile",
  "Type to search": "testo da cercare",
  "Add Another": "Aggiungi",
  "File Name": "Nome del file",
  "Please save all rows before proceeding.": "Cliccare sul tasto 'salva' prima di procedere",
  "File is the wrong type; it must be {{ pattern }}": "Tipo di file non accettato. I tipi di file accetati sono {{ pattern }}",
  "File is too big; it must be at most {{ size }}": "Il file è troppo grande. La dimensione massima è {{ size }}",
  "Invalid row. Please correct it or delete.": "Riga non valida. Correggere o cancellare.",
  "Please correct invalid rows before proceeding.": "Correggere le righe non valide prima di procedere",
  "Size": "Dim.",
  "Save": "Salva",
  "Cancel": "Cancella",
  "Edit": "Modifica",
  "Delete": "Cancella",
  "Yes:": "Sì",
  "No": "No",
  "Day": "giorno",
  "Month": "mese",
  "Year": "anno",
  "january": "Gennaio",
  "february": "Febbraio",
  "march": "Marzo",
  "april": "Aprile",
  "may": "Maggio",
  "june": "Giugno",
  "july": "Luglio",
  "august": "Agosto",
  "september": "Settembre",
  "october": "Ottobre",
  "november": "Novembre",
  "december": "Dicembre",
  // ESEMPI TI LABEL
  "Nome": "First Name",
  "Cognome": "Last Name",
  // ESEMPIO DI DESC MODULO
  "Identità del segnalante": "identity",
  // ESEMPIO PLACEHOLDER
  "Inserire Nome del Soggetto Segnalante": "insert first name",
  "Inserire Cognome del Soggetto Segnalante": "insert last name",
  // ESEMPIO DI TOOLTIP
  "sono accettati seguenti formati: pdf, jpg, jpeg, png": "document",
  // ESEMPIO DI VALORI DELLE SELECT
  "Carta d'identità": "National ID Card",
  "Passaporto": "Passport",
  "Patente": "Drive License",
  "Area Vigilanza Appalti / Concessioni / Contratti Pubblici": "Public Procurement / Concessions / Public Contracts Surveillance Area",
  "Quest’area è deputata alla ricezione di tutte le segnalazioni che riguardano violazioni della disciplina sull’affidamento e l’esecuzione di contratti pubblici di lavori, servizi e forniture, sia che si tratti di appalti sia che si tratti di concessioni. Confluiscono in quest’area anche tutte le segnalazioni riferite a: partenariato pubblico privato; finanza di progetto; in house;  centrali di committenza; conflitti di interesse nello svolgimento delle procedure di aggiudicazione di appalti e concessioni; contratti secretati; affidamenti a contraente generale. È possibile consultare il Regolamento ANAC in materia vi vigilanza sui contratti pubblici del 8.3.2018 (G.U. Serie Generale n. 241 del 16.10.2018) sul sito istituzionale dell’Autorità.": "This area is designated for receiving all reports concerning violations of the discipline on the award and execution of public contracts for works, services, and supplies, whether they are contracts or concessions. Also included in this area are all reports related to: public-private partnerships; project finance; in-house arrangements; procurement centers; conflicts of interest in the conduct of tendering procedures for contracts and concessions; classified contracts; contracts awarded to general contractors. It is possible to consult the ANAC Regulation on supervision of public contracts dated 8.3.2018 (Official Gazette Series General no. 241 of 16.10.2018) on the institutional website of the Authority."
}
